/** Estilo de diálogo alineado con moodboards / meetings (blur + rise). */
import { keyframes } from "@emotion/react";

export const studioDialogBackdropSx = {
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  backgroundColor: "rgba(15, 23, 42, 0.45)",
};

export const studioDialogPaperSx = {
  borderRadius: 3,
  overflow: "hidden",
  border: "1px solid",
  borderColor: "divider",
};

export const motionSafe = {
  "@media (prefers-reduced-motion: reduce)": { animation: "none" },
};

export const rise = keyframes`
  from { opacity: 0; transform: translateY(10px) scale(0.97); }
  to { opacity: 1; transform: translateY(0) scale(1); }
`;

export const bob = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
`;

export const pop = keyframes`
  0%, 12% { opacity: 0.25; transform: translateY(6px) scale(0.9); }
  35%, 68% { opacity: 1; transform: translateY(0) scale(1); }
  100% { opacity: 0.35; transform: translateY(3px) scale(0.95); }
`;

export const swapSlide = keyframes`
  0%, 15% { transform: translateX(0) scale(1); opacity: 1; }
  45% { transform: translateX(18px) scale(0.92); opacity: 0.45; }
  55% { transform: translateX(-18px) scale(0.92); opacity: 0.45; }
  85%, 100% { transform: translateX(0) scale(1); opacity: 1; }
`;

export const cloudLift = keyframes`
  0%, 100% { transform: translateY(0) scale(1); }
  40% { transform: translateY(-6px) scale(1.04); }
  70% { transform: translateY(-2px) scale(1.01); }
`;

export const softPulse = keyframes`
  0%, 100% { opacity: 0.45; transform: scale(1); }
  50% { opacity: 0.85; transform: scale(1.06); }
`;

export const shimmerSweep = keyframes`
  0% { transform: translateX(-120%) skewX(-12deg); opacity: 0; }
  35% { opacity: 0.55; }
  100% { transform: translateX(220%) skewX(-12deg); opacity: 0; }
`;

export const fanIn = keyframes`
  from { opacity: 0; transform: translateY(16px) rotate(var(--from-rot, 0deg)) scale(0.88); }
  to { opacity: 1; transform: translateY(0) rotate(var(--to-rot, 0deg)) scale(1); }
`;

export const staggerIn = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const floatOrbit = keyframes`
  0%, 100% { transform: translate(0, 0); }
  33% { transform: translate(4px, -5px); }
  66% { transform: translate(-3px, 3px); }
`;
